<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.paytable" :value="rulePaytable" />
    </div>
  </div>
</template>

<script>
import Ffbanner from '../../assets/gamerule/fishing/FF_Board_Web.png';
import Ffrule1 from '../../assets/gamerule/fishing/FF_Info_Game_1.png';
import Ffrule2 from '../../assets/gamerule/fishing/FF_Info_Game_2.png';
import Fsrule from '../../assets/gamerule/fruitslot/fruit_text1.png';
import Ffrule3 from '../../assets/gamerule/fishing/FF_Info_Game_3.png';
import Ffrule4 from '../../assets/gamerule/fishing/FF_Info_Game_4.png';
import Ffrule5 from '../../assets/gamerule/fishing/FF_Info_Game_5.png';
import Ffrule6 from '../../assets/gamerule/fishing/FF_Info_Game_6.png';
import Ffrule7 from '../../assets/gamerule/fishing/FF_Info_Game_7.png';
import Ffrule8 from '../../assets/gamerule/fishing/FF_Info_Game_8.png';
import Ffrule9 from '../../assets/gamerule/fishing/FF_Info_Game_9.png';
import Ffrule10 from '../../assets/gamerule/fishing/FF_Info_Game_10.png';
import Ffrule11 from '../../assets/gamerule/fishing/FF_Info_Game_11.png';
import Ffrule12 from '../../assets/gamerule/fishing/FF_Info_Game_12.png';
import Ffrule13 from '../../assets/gamerule/fishing/FF_Info_Game_13.png';
import Ffrule14 from '../../assets/gamerule/fishing/FF_Info_Game_14.png';
import Ffrule15 from '../../assets/gamerule/fishing/FF_Info_Game_15.png';
import Ffasset1 from '../../assets/gamerule/fishing/FF_Asset_Info_Web_1.png';
import Ffasset2 from '../../assets/gamerule/fishing/FF_Asset_Info_Web_2.png';
import Ffasset3 from '../../assets/gamerule/fishing/FF_Asset_Info_Web_3.png';
import Ffasset4 from '../../assets/gamerule/fishing/FF_Asset_Info_Web_4.png';
import Ffasset5 from '../../assets/gamerule/fishing/FF_Asset_Info_Web_5.png';

export default {
  name: 'rule_friutslot',
  data() {
    return {
      ruleHeader: {
        gameName: 'ทุ่งรักนักตกปลา (Lets Fishing Field)',
        boardImg: Ffbanner,
      },
      ruleTitle: {
        paytable: 'ค่าเฉลี่ยน้ำหนักและมูลค่าของปลาแต่ละชนิด',
      },
      ruleGame: [
        {
          image: Fsrule,
          type: 'imageNoborderSlot',
          class: 'w-30 ml-3',
        },
        {
          type: 'textBg2Color',
          text: 'เมื่อเข้าเล่นมินิเกมส์',
          textCol: ' Lets Fishing Field ',
          text2: 'เกมส์จะทำการให้ผู้เล่นเลือกตัวละครก่อนเริ่มเกมส์',
        },
        {
          type: 'textBg2',
          text:
            'โดยตัวละครจะไม่มีผลต่อการเล่นระหว่างเกมส์ แต่จะมีเสียงของตัวละครที่ทำให้ผู้เล่นรู้สึกผ่อนคลาย',
        },
        {
          type: 'textBg1Color',
          text: 'สามารถกดที่ตัวละครแล้วกดปุ่ม',
          textCol: ' เลือก',
        },
        {
          type: 'twoImage',
          image: Ffrule1,
          image2: Ffrule2,
        },
        {
          type: 'textBg1ColorNew',
          textCol: 'BET',
          text: 'สามารถเพิ่มและลดจำนวนเดิมพัน',
        },
        {
          type: 'textBg2',
          text: 'โดยมีผลต่อลักษณะเบ็ดตกปลาที่สวยมากขึ้น 3 ระดับ',
        },
        {
          type: 'threeImage',
          image: Ffrule3,
          image2: Ffrule4,
          image3: Ffrule5,
        },
        {
          type: 'textBg2Color',
          text: 'ผู้เล่นสามารถเช็ค',
          textCol: ' ประวัติ ',
          text2: 'ได้ที่มุมขวาของหน้าจอ',
        },
        {
          type: 'textBg2',
          text: 'หน้าต่างประวัติจะแสดงจำนวนสิ่งที่ผู้เล่นตกได้และจำนวนที่ผู้เล่นได้รับ',
        },
        {
          type: 'twoImage',
          image: Ffrule6,
          image2: Ffrule7,
        },
        {
          type: 'textBg2Color',
          text: 'วิธีการเล่นมินิเกมส์',
          textCol: ' Lets Fishing Field ',
          text2: 'แตะที่หน้าจอเพื่อทำการขว้างเหยื่อไปตามตำแหน่งที่ต้องการ',
        },
        {
          type: 'textBg2',
          text: 'โดยที่ผู้เล่นสามารถแตะตรงไหนก็ได้ ภายในบ่อน้ำเท่านั้น (หากต้องการเปลี่ยนตำแหน่งปุ่ม สามารถกดลากได้เลย)',
        },
        {
          type: 'twoImage',
          image: Ffrule8,
          image2: Ffrule9,
        },
        {
          type: 'textBg2Color2',
          text: 'หากมีปลามากินเหยื่อ หน้าต่างจะปรากฏ',
          textCol: ' Fish HP ',
          text2: 'ผู้เล่นต้องกดปุ่ม',
          textCol2: ' Fishing ',
          text3: 'หรือปุ่มขวาล่างเพื่อสู้กับปลาในแต่ละรอบ',
        },
        {
          type: 'textBg2Color2New',
          textCol: 'Fish HP ',
          text: 'ชีวิตของปลาแต่ละตัวและเวลาให้การต่อสู้จะไม่เท่ากัน',
          textCol2: ' ยิ่งเป็นปลาหายาก การต่อสู้จะยิ่งนานขึ้น',
        },
        {
          type: 'twoImage',
          image: Ffrule10,
          image2: Ffrule11,
        },
        {
          type: 'textBg2ColorRed',
          textCol: 'กรณีเบ็ดขาด ',
          text: 'ก็คือผู้เล่นไม่สามารถกดตกปลาตัวนั้น',
          textCol2: ' ต้องระวังด้วยล่ะ!',
        },
        {
          type: 'twoImage',
          image: Ffrule12,
          image2: Ffrule13,
        },
        {
          type: 'textBgRedGreen',
          text: 'หากผู้เล่นสามารถเอาชนะปลารอบนั้นได้ ( ระดับ',
          textCol: ' ยาก ',
          textCol2: '-',
          textCol3: ' ง่าย ',
          text2: 'ขึ้นอยู่กับความหายากของชนิดนั้น )',
        },
        {
          type: 'textBg2',
          text: 'อนิเมชั่นจะปรากฏขึ้น หน้าสรุปผลจะแสดงรูปปลาหรือสิ่งของ ( น้ำหนัก , จำนวนเงินเดิมพัน , จำนวนยอดรวม )',
        },
        {
          type: 'textBg1Color',
          text: 'ที่ผู้เล่นได้รับ หากผู้เล่นต้องการเล่นต่อ กดปุ่ม ',
          textCol: 'เล่นต่อ',
        },
        {
          type: 'twoImage',
          image: Ffrule15,
          image2: Ffrule14,
        },
      ],
      rulePaytable: [
        {
          type: 'textBg2Color2',
          text: 'ระดับความมีค่าของ',
          textCol: ' ปลา ',
          text2: 'และ',
          textCol2: ' สิ่งของ ',
          text3: 'ละชนิด มีดั่งนี้',
        },
        {
          type: 'imageTextFish',
          textHead: 'มูลค่าของปลาแต่ละชนิด',
          image: Ffasset1,
          class: 'w-90',
        },
        {
          type: 'imageTextFish2',
          textHead: 'สิ่งของไร้มูลค่าแต่ละชนิด',
          data: [
            {
              text: 'รองเท้าบูท (Boot)',
              textCon: 'Useless',
              image: Ffasset2,
              class: 'w-50',
              textFooter: 'HP : 1,000 - 3,000',
              textFooter_2: 'น้ำหนัก : 1 - 5 kg.',
              textFooter_3: 'จำนวนคูณ : ',
              textFooter_31: 'FAIL',
              textFooter_4: '*** รองเท้าบูทไร้คู่',
            },
            {
              text: 'ถุงขยะ (Garbage)',
              textCon: 'Useless',
              image: Ffasset3,
              class: 'w-50',
              textFooter: 'HP : 900 - 1,200',
              textFooter_2: 'น้ำหนัก : 0.5-2 kg.',
              textFooter_3: 'จำนวนคูณ : ',
              textFooter_31: 'FAIL',
              textFooter_4: '*** ถุงขยะที่ผู้คนทิ้งไม่เป็นที่',
            },
            {
              text: 'กระป๋อง (Can)',
              textCon: 'Useless',
              image: Ffasset4,
              class: 'w-50',
              textFooter: 'HP : 750 - 1,000',
              textFooter_2: 'น้ำหนัก : 0.25 - 1.25 kg.',
              textFooter_3: 'จำนวนคูณ : ',
              textFooter_31: 'FAIL',
              textFooter_4: '*** กระป๋องที่ว่างเปล่า',
            },
            {
              text: 'กิ่งไม้ (Log)',
              textCon: 'Useless',
              image: Ffasset5,
              class: 'w-50',
              textFooter: 'HP : 500 - 700',
              textFooter_2: 'น้ำหนัก : 0.3 kg.',
              textFooter_3: 'จำนวนคูณ : ',
              textFooter_31: 'FAIL',
              textFooter_4: '*** กิ่งไม้ที่ไม่มีประโยชน์',
            },
          ],
        },
      ],
    };
  },
};
</script>
